export function getAudienceImportSessionKey(sessionId: string) {
  return sessionId ? (['audience-import-session', sessionId] as const) : null
}

export function getAudienceImportIdentityShellKey(sessionId: string) {
  return sessionId ? (['audience-import-identity-shell', sessionId] as const) : null
}

export function getAudienceImportIdentitySourceOptionsKey(
  sessionId: string,
  canonicalId: string | null,
  query = '',
  offset = 0,
  limit = 50,
) {
  return sessionId && canonicalId
    ? ([
        'audience-import-identity-source-options',
        sessionId,
        canonicalId,
        query,
        offset,
        limit,
      ] as const)
    : null
}

/**
 * Value-map workspace is keyed by the active source column as well. Without it,
 * SWR reuses a single row per (session, field) and shows the previous column’s
 * distincts/value map until a slow refetch finishes (and keepPreviousData can
 * flash stale rows after “Use this column”).
 */
export function getAudienceImportIdentityValueMapKey(
  sessionId: string,
  canonicalId: string | null,
  valueMapSourceKey?: string | null,
) {
  return sessionId && canonicalId
    ? (['audience-import-identity-value-map', sessionId, canonicalId, valueMapSourceKey ?? ''] as const)
    : null
}

export function getAudienceImportFlowSnapshotKey(sessionId: string) {
  return sessionId ? (['audience-import-flow-snapshot', sessionId] as const) : null
}

/** SWR key for the latest resumable import session (new-audience page). */
export const AUDIENCE_IMPORT_LATEST_KEY = ['audience-import-latest'] as const

export function getAudienceImportContextMaterialsProjectionKey(sessionId: string) {
  return sessionId
    ? (['audience-import-context-materials-projection', sessionId] as const)
    : null
}

export function getAudienceImportWorkbookProjectionKey(sessionId: string) {
  return sessionId
    ? (['audience-import-workbook-projection', sessionId] as const)
    : null
}

export function getAudienceImportPreviewProjectionKey(sessionId: string) {
  return sessionId
    ? (['audience-import-preview-projection', sessionId] as const)
    : null
}

export function getAudienceImportStatusProjectionKey(sessionId: string) {
  return sessionId
    ? (['audience-import-status-projection', sessionId] as const)
    : null
}
